module.exports = __webpack_public_path__ + "static/media/xIconBlack.65f10754.svg";